<template>
  <div id="ring-main-header">
    <div class="nav-left">
      <div class="title">
        <!-- <slot name="arrow-back">
          <i class="el-icon-back"/>
        </slot> -->
        <slot name="page-title">
          Page Title
        </slot>
      </div>

      <div class="sub-title">
        <slot name="sub-title">
          {{ customer.email }}
        </slot>
        <span
            v-if="isLocked"
            style="display: block;padding-top: 2px;font-size: large;color: red;font-weight: 500;">
          ACCOUNT IS DISABLED!
        </span>
      </div>
    </div>
    <div class="nav-right">
      <ul class="nav-form">
        <li v-if="showOneOffButton">
          <one-off-button />
        </li>
        <li v-if="showPlcButton">
          <plc-button />
        </li>
        <li>
          <main-search />
        </li>
        <li>
          <user-options />
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import UserOptions from "./UserOptions";
import MainSearch from "./Search";
import OneOffButton from "@/components/Shared/OneOffButton";
import PlcButton from "@/components/Shared/PlcButton";

import { createNamespacedHelpers } from "vuex";

const { mapGetters: accountGetters } = createNamespacedHelpers("db/account");

export default {
  name: "MainHeader",
  components: {
    UserOptions,
    MainSearch,
    OneOffButton,
    PlcButton,
  },
  props: {
    showPlcButton: {
      type: Boolean,
      default: () => {
        return false;
      },
    },
    showOneOffButton: {
      type: Boolean,
      default: () => {
        return false;
      },
    },
  },
  data() {
    return {
      search: "",
      oneOffModalShow: false,
    };
  },
  computed: {
    ...accountGetters(["customer", "isLocked"]),
  },
};
</script>

<style lang="scss">
section > main.el-main {
  padding: 41px 48px;
}

#ring-main-header {
  margin: 0px 0px 15px 0px;
  height: 55px;
  padding: 0 50px 0 0px;
  @media screen and (max-width: 1280px) {
    height: fit-content;
  }

  .nav-left {
    float: left;
  }
  .nav-right {
    float: right;
  }

  .nav-left,
  .nav-right {
    @media screen and (max-width: 1280px) {
      float: none;
    }
  }

  .nav-left .title {
    font-size: 24px;
    color: #4c4c4c;
    font-weight: 300;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 40rem;
  }
  .nav-left .title a {
    font-size: 28px;
    color: #4c4c4c;
    font-weight: 300;
  }
  .nav-left .sub-title {
    font-size: 16px;
    color: #999999;
    padding-left: 0px;
  }

  .nav-right ul.nav-form {
    display: inline-block;
    list-style: none;
    margin: 0px;
    padding: 0px;
  }
  .nav-right ul.nav-form li {
    float: left;
    padding: 5px;
    margin-left: 20px;
  }
  .nav-right ul.nav-form li a.nav-action {
    text-decoration: none;
    font-size: 15px;
    color: $--color-curious-blue;
    text-align: center;
    height: 45px;
    line-height: 45px;
  }
  .nav-right ul.nav-form li .nav-search input {
    height: 40px;
    width: 300px;
    line-height: 40px;
    border-radius: 30px;
  }
}
</style>
